<div style="height: 500px" class="flex-row">
  <div class="wrapper centered aligned">
    <mat-spinner [strokeWidth]="1"></mat-spinner>
  </div>
</div>
